import { useState, useRef, useEffect } from "react";
import { Lock } from "@phosphor-icons/react";

const CORRECT_PIN = "2376";

const PinLock = ({ onUnlock }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 7);
    setPin(val);
    setError(false);

    if (val.length === 7) {
      if (val === CORRECT_PIN) {
        sessionStorage.setItem("pin_unlocked", "1");
        onUnlock();
      } else {
        setError(true);
        setTimeout(() => {
          setPin("");
          setError(false);
        }, 800);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && pin.length > 0) {
      if (pin === CORRECT_PIN) {
        sessionStorage.setItem("pin_unlocked", "1");
        onUnlock();
      } else {
        setError(true);
        setTimeout(() => {
          setPin("");
          setError(false);
        }, 800);
      }
    }
  };

  return (
    <div
      className="fixed inset-0 bg-[#0D0F12] flex items-center justify-center z-[9999]"
      data-testid="pin-lock-screen"
      onClick={() => inputRef.current?.focus()}
    >
      <div className="flex flex-col items-center gap-6">
        <div
          className={`w-16 h-16 rounded-full flex items-center justify-center transition-colors ${
            error ? "bg-red-500/20" : "bg-[#2196F3]/20"
          }`}
        >
          <Lock
            size={32}
            className={`transition-colors ${error ? "text-red-400" : "text-[#2196F3]"}`}
          />
        </div>

        <p className="text-[#8A9099] text-sm">Введите PIN-код</p>

        {/* Dots */}
        <div className="flex gap-3">
          {Array.from({ length: 7 }).map((_, i) => (
            <div
              key={i}
              className={`w-3 h-3 rounded-full transition-all duration-150 ${
                error
                  ? "bg-red-400"
                  : i < pin.length
                  ? "bg-[#2196F3]"
                  : "bg-[#252A33]"
              } ${error ? "animate-shake" : ""}`}
            />
          ))}
        </div>

        {/* Hidden input */}
        <input
          ref={inputRef}
          type="tel"
          inputMode="numeric"
          value={pin}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          className="sr-only"
          autoFocus
          data-testid="pin-input"
        />

        {error && (
          <p className="text-red-400 text-xs" data-testid="pin-error">
            Неверный PIN
          </p>
        )}
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20%, 60% { transform: translateX(-4px); }
          40%, 80% { transform: translateX(4px); }
        }
        .animate-shake { animation: shake 0.4s ease-in-out; }
      `}</style>
    </div>
  );
};

export default PinLock;
